export enum DOWNLOAD_FILE_ERROR {
  GENERIC = 'GENERIC',
  PERMISSION_DENIED = 'PERMISSION_DENIED',
  URL_MISSING = 'URL_MISSING',
}
